module.exports = __webpack_public_path__ + "static/amarok-canyon-7bbc2b4cc1cd318a3dffc5bdcc2a07d5.png";